import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { settings } from '../../app.settings';
import { map } from "rxjs/operators";

const API_PATH = settings.api.url;

export function downloadFile(content, name: string) {
  const link = document.createElement('a')
  const url = window.URL.createObjectURL(new Blob([ content ]))

  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
}

export function previewFile(content, mimeType: string = 'application/pdf') {
  const url = window.URL.createObjectURL(new Blob([ content ], {
    type: mimeType
  }))

  window.open(url);
}

@Injectable()
export class FileService {

  constructor(private http: HttpClient) { }

  getUrl(file) {
    if (!file) {
      return;
    }

    if (file.url) {
      return API_PATH + '/' + file.url;
    } else {
      return API_PATH + '/files/' + file + '/preview';
    }
  }

  upload(file: File, params = {}) {
    const formData = new FormData();
    formData.append('file', file);

    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    return this.http.post(settings.api.url + '/files', formData);
  }

  fetchIllustrationUsages(illustrationUsageType: string) {
    return this.http.get(settings.api.url + '/files/' + illustrationUsageType + '/illustration_usages').pipe(map(
      (response: any) => {
        const illustrationUsages = response.illustration_usages ? response.illustration_usages : [];
        return illustrationUsages.sort((a, b) => (a._order ?? 0) - (b._order ?? 0));
      }
    ));
  }

  download(file, name, onComplete?: () => void) {
    file = file.replace('http://', 'https://')

    return this.http.get(file, {
      responseType: 'blob'
    })
      .subscribe((response: any) => {
        downloadFile(response, name)

        if (onComplete) {
          onComplete()
        }
      })
  }

  preview(file, mimeType = 'application/pdf') {
    file = file.split('?')[0].replace('http://', 'https://')

    return this.http.get(file, {
      responseType: 'blob'
    })
      .subscribe((response: any) => {
        previewFile(response, mimeType)
      })
  }
}
